import snComboboxDeprecated from '~/components/snui/v2/_deprecated/snCombobox/snComboboxDeprecated'
import SnCurrencyDeprecated from '~/components/snui/v2/_deprecated/snCurrencyDeprecated/snCurrencyDeprecated'
import snRadioDeprecated from '~/components/snui/v2/_deprecated/snRadio/snRadioDeprecated'
import SnSelectCheckboxDeprecated from '~/components/snui/v2/_deprecated/snSelectCheckbox/snSelectCheckboxDeprecated'
import SnSelectDeprecated from '~/components/snui/v2/_deprecated/snSelect/snSelectDeprecated'
import SnSelectDropdownDeprecated from '~/components/snui/v2/_deprecated/snSelectDropdown/snSelectDropdownDeprecated'
import SnTextDeprecated from '~/components/snui/v2/_deprecated/snText/snTextDeprecated'

import SnAutocomplete from '~/components/snui/v2/snDropdowns/snAutocomplete'
import SnAvatar from '~/components/snui/v2/snAvatar/snAvatar'
import snCombobox from '~/components/snui/v2/snDropdowns/snCombobox'
import SnTaskCard from '~/components/snui/v2/snTaskCard/snTaskCard'
import SnBtn from '~/components/snui/v2/snBtn/snBtn'
import SnCurrency from '~/components/snui/v2/snCurrency/snCurrency'
import SnDatePicker from '~/components/snui/v2/snDatePicker/snDatePicker'
import SnDownpaymentPercentage from '~/components/snui/v2/snDownpaymentPercentage/snDownpaymentPercentage'
import SnExpansionPanel from '~/components/snui/v2/snExpansionPanel/snExpansionPanel'
import SnExpansionPanels from '~/components/snui/v2/snExpansionPanel/snExpansionPanels'
import SnFileInput from '~/components/snui/v2/snFileInput/snFileInput'
import SnGradientHeader from '~/components/snui/v2/snGradientHeader/snGradientHeader'
import SnIllustration from '~/components/snui/v2/snIllustration/snIllustration'
import SnLabel from '~/components/snui/v2/snLabel/snLabel'
import SnModal from '~/components/snui/v2/snModal/snModal'
import SnPagination from '~/components/snui/v2/snPagination/snPagination'
import SnRadio from '~/components/snui/v2/snRadioGroup/snRadio'
import SnRadioGroup from '~/components/snui/v2/snRadioGroup/snRadioGroup'
import SnBoolean from '~/components/snui/v2/snBoolean/snBoolean'
import snSearch from '~/components/snui/v2/snSearch/snSearch'
import SnSelect from '~/components/snui/v2/snDropdowns/snSelect'
import SnShadow from '~/components/snui/v2/snShadow/snShadow'
import SnSsn from '~/components/snui/v2/snSsn/snSsn'
import SnTable from '~/components/snui/v2/snTable/snTable'
import SnTextField from '~/components/snui/v2/snTextField/snTextField'
import SnTextarea from '~/components/snui/v2/snTextarea/snTextarea'
import SnZeroStateCard from '~/components/snui/v2/snZeroStateCard/snZeroStateCard'
import SnToast from '~/components/snui/v2/snToast/snToast'
import SnPassword from '~/components/snui/v2/snPassword/snPassword'
import SnPhone from '~/components/snui/v2/snPhone/snPhone'
import SnSwitch from '~/components/snui/v2/snSwitch/snSwitch'
import SnTooltip from '~/components/snui/v2/snTooltip/snTooltip'

export default {
  snComboboxDeprecated,
  SnCurrencyDeprecated,
  snRadioDeprecated,
  SnSelectCheckboxDeprecated,
  SnSelectDeprecated,
  SnSelectDropdownDeprecated,
  SnTextDeprecated,

  SnAutocomplete,
  SnAvatar,
  snCombobox,
  SnTaskCard,
  SnBtn,
  SnCurrency,
  SnDatePicker,
  SnDownpaymentPercentage,
  SnExpansionPanel,
  SnExpansionPanels,
  SnFileInput,
  SnGradientHeader,
  SnIllustration,
  SnLabel,
  SnModal,
  SnPagination,
  SnRadio,
  SnRadioGroup,
  SnBoolean,
  snSearch,
  SnSelect,
  SnShadow,
  SnSsn,
  SnTable,
  SnTextField,
  SnTextarea,
  SnZeroStateCard,
  SnToast,
  SnPassword,
  SnPhone,
  SnSwitch,
  SnTooltip
}
